import { Link } from "react-router-dom";
import Logo from "../../components/logo";

const Footer = () => {
    return (
        <footer className="footer-area">
            <div className="container">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="widget-item">
                            <div className="about-widget">
                                <Logo classOption="footer-logo" image={`${process.env.PUBLIC_URL}/img/logo2.png`} />
                                <p className="mb-0">두 세대에 걸쳐 이어져 온 진심 어린 마음으로 환자분의 건강한 피부를 위해 최선을 다합니다.</p>
                                <ul className="widget-contact-info">
                                    <li className="info-address">
                                        <i className="icofont-location-pin"></i>
                                        경기 안산시 단원구 중앙대로 915 월드코아 5층
                                    </li>
                                    <li className="info-phone">
                                        <i className="icofont-ui-call"></i>
                                        031-402-7500 (카톡/전화 예약 미운영)
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="widget-item">
                            <h4 className="widget-title line-bottom">진료 분야</h4>
                            <div className="widget-tags">
                                <ul>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/1"}>피부염</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/2"}>아토피</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/2"}>건선</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/5"}>기미</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/4"}>탈모</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/5"}>레이저</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/8"}>리프팅</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/7"}>필러</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/7"}>보톡스</Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/service-details/9"}>제모</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-4">
                        <div className="widget-item">
                            <h4 className="widget-title line-bottom">진료 시간</h4>
                            <nav className="widget-posts">
                                <ul className="posts-item">
                                    <li>
                                        <i className="icon icofont-rounded-double-right"></i>
                                        월·화·목·금 06:30 - 15:30
                                    </li>
                                    <li>
                                        <i className="icon icofont-rounded-double-right"></i>
                                        토요일 05:30 - 10:30
                                    </li>
                                    <li>
                                        <i className="icon icofont-rounded-double-right"></i>
                                        수요일·일요일 휴진
                                    </li>
                                    <li>
                                        <i className="icon icofont-rounded-double-right"></i>
                                        접수는 진료 종료 전 조기 마감됩니다
                                    </li>
                                    <li>
                                        <i className="icon icofont-rounded-double-right"></i>
                                        시술 상담은 네이버 예약만 가능
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-sm-12">
                            <div className="widget-copyright">
                                <p>
                                    &copy; 2026 <span className="text-uppercase">정환교피부과의원</span>. 모든 권리 보유.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
